import { render, staticRenderFns } from "./hysy.vue?vue&type=template&id=63829666"
import script from "./hysy.vue?vue&type=script&lang=js"
export * from "./hysy.vue?vue&type=script&lang=js"
import style0 from "./hysy.vue?vue&type=style&index=0&id=63829666&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports